//
// 复选框
// ============================================================
import Ns from "./utility";

const Checkbox = () => new Ns({
    el: ".checkbox-wrapper",
    eventHandle: {
        type: "click",
        entrust: ".checkbox-group",
        callback:  function (ev) {

            // 禁用状态
            if(ns(this).hasClass("disabled")){
                ns(this).attr("title", "禁用状态");
                return true ;
            }

            // 获取选中的data-checkbox-id
            let checkboxId = ns(this).parents(".checkbox-wrapper").attr("data-checkbox-checked-id") == null ? [] : ns(this).parents(".checkbox-wrapper").attr("data-checkbox-checked-id").replace(/^\,/, "").split(",");

            // 定义图标
            let userDefinedDefault = ns(this).parents(".checkbox-wrapper").attr("data-icon-default");
            let userDefinedChecked = ns(this).parents(".checkbox-wrapper").attr("data-icon-checked");
            let isUserDefinedChecked = !userDefinedChecked ? "icon-squarecheck" : userDefinedChecked;
            let isUserDefinedDefault = !userDefinedDefault ? "icon-square" : userDefinedDefault;

            let selectAllIco = ns(this).parents(".checkbox-wrapper").find(".checkbox-group[data-checkbox-status]").find(".iconfont");
            let selectAll = ns(this).parents(".checkbox-wrapper").find(".checkbox-group[data-checkbox-status]");

            // 全选
            // =========================================================
            if(ns(this).attr("data-checkbox-status") == "all"){

                selectAllIco.toggleClass(isUserDefinedChecked).toggleClass(isUserDefinedDefault);
                checkboxId = [];

                Ns.each(ns(this).parents(".checkbox-wrapper").find(".checkbox-group[data-checkbox-id]").get(), item => {
                    let iconfont = ns(item).find(".iconfont");

                    if (!ns(item).hasClass("disabled")){
                        // 反选
                        if (!selectAllIco.hasClass(isUserDefinedChecked)){
                            ns(item).attr("data-checkbox-checked", false);
                            iconfont.removeClass(isUserDefinedChecked).addClass(isUserDefinedDefault);
                            selectAll.attr("data-checkbox-checked", false)

                        }else {

                            // 全选
                            ns(item).attr("data-checkbox-checked", true);
                            selectAll.attr("data-checkbox-checked", true);
                            iconfont.removeClass(isUserDefinedDefault).addClass(isUserDefinedChecked).removeAttr("data-checkbox-id");
                            checkboxId.push(ns(item).attr("data-checkbox-id"));
                        }
                    }else {
                        // 禁用选中
                        if (ns(item).attr("data-checkbox-checked") == "true"){
                            checkboxId.push(ns(item).attr("data-checkbox-id"))
                        }
                    }

                });
                ns(this).parents(".checkbox-wrapper").attr("data-checkbox-checked-id", checkboxId);

            }else {

                // 非全选
                // =========================================================
                // 反选
                if(ns(this).find(".iconfont").hasClass(isUserDefinedChecked)){
                    ns(this).attr("data-checkbox-checked", false).find(".iconfont").removeClass(isUserDefinedChecked).addClass(isUserDefinedDefault);

                    let nowId = ns(this).attr("data-checkbox-id");
                    checkboxId = checkboxId.filter( item => item != nowId);
                    selectAllIco.removeClass(isUserDefinedChecked).addClass(isUserDefinedDefault);
                    selectAll.attr("data-checkbox-checked", false);
                }else {

                    // 选中
                    ns(this).attr("data-checkbox-checked", true).find(".iconfont").addClass(isUserDefinedChecked).removeClass(isUserDefinedDefault);
                    checkboxId.push(ns(this).attr("data-checkbox-id"));
                    selectAll.attr("data-checkbox-checked", true);
                }

                ns(this).parents(".checkbox-wrapper").attr("data-checkbox-checked-id", checkboxId);

                // 兼容全选
                if (selectAllIco.get().length == 0) return true;
                selectAllIco.removeClass(isUserDefinedChecked).addClass(isUserDefinedDefault);
                selectAll.attr("data-checkbox-checked", false);

                let checkboxGroupLength = ns(this).parents(".checkbox-wrapper").find('.checkbox-group[data-checkbox-id]').get().length;
                let disabledLength = ns(this).parents(".checkbox-wrapper").find('.checkbox-group.disabled[data-checkbox-checked="false"]').get().length;

                if ((checkboxGroupLength - disabledLength) == checkboxId.length) {
                    selectAllIco.removeClass(isUserDefinedDefault).addClass(isUserDefinedChecked);
                    selectAll.attr("data-checkbox-checked", true);
                }
            }

            return true;
        }
    },
    load() {
        let checkboxId = [];
        Ns.each(ns(this).find(".checkbox-group[data-checkbox-checked=true]").get(),item => {
            let iconChecked = ns(item).parents(".checkbox-wrapper").attr("data-icon-checked");
            let iconDefault = ns(item).parents(".checkbox-wrapper").attr("data-icon-default");

            if (!iconChecked) {
                iconChecked = "icon-squarecheck"
            }
            if (!iconDefault) {
                iconDefault = "icon-square"
            }
            ns(item).find(".iconfont").removeClass(iconDefault).addClass(iconChecked);
            checkboxId.push(ns(item).attr("data-checkbox-id"));
        });
        ns(this).attr("data-checkbox-checked-id", checkboxId);
    },
});

module.exports = Checkbox;


// WEBPACK FOOTER //
// src/js/checkbox.js